// extracted by mini-css-extract-plugin
module.exports = {"sectionBigTitle":"SectionTitle_sectionBigTitle__zd8CO","sectionTitle":"SectionTitle_sectionTitle__u2BKO","subTitle":"SectionTitle_subTitle__U6hVo"};